import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Landing from "./pages/Landing.js";
import Search from "./pages/Search";
import Livros from "./pages/Livros";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Users from "./pages/Users";
import SearchUser from "./pages/SearchUser.js";
import LibraryCreate from "./functions/LibraryCreate.js";
import Libraries from "./pages/Libraries";
import AddBookToLibrary from "./functions/addBookToLibrary.js";
import History from "./pages/History.js";
import SearchLibrary from "./pages/SearchLibrary.js";
export default function Routes() {

    return (
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={Landing} />
                <Route path="/procurar/:type/:price/:nome" component={Search} />
                <Route path="/livros/:id" component={Livros} />
                <Route path="/login" component={Login} />
                <Route path="/signup" component={Signup} />
                <Route path="/users/:id" component={Users} />
                <Route path="/create/library/:id" component={LibraryCreate} />
                <Route path="/libraries/:libraryid" component={Libraries} />
                <Route path="/community/users/:username" component={SearchUser} />
                <Route path="/community/libraries/:libraryid" component={SearchLibrary} />
                <Route path="/adbooksto/library/:libraryid/:bookid" component={AddBookToLibrary} />
                <Route path="/history/:userid" component={History} />
            </Switch>
        </BrowserRouter>
    )
}